module.exports = __webpack_public_path__ + "static/media/15.187e731c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/悬浮窗/15.png
// module id = 1659
// module chunks = 0